var isPublic = location.pathname.indexOf('/LEAP') == -1;
// page init
jQuery(function($){
	MenuFix('#nav',true);
	MenuFix('#sub-nav',false);
// 	if(isTouchDevice) {
// 		initMobileDrop();
// 	} else {
		initDropDown();
		jQuery('body').addClass('desctop');
// 	}
	initInputs();
	$('.images li').mouseenter(
		function(){
			$(this).children('.box').toggle();
		}
	);
	$('.images li').mouseleave(
		function(){
			$(this).children('.box').toggle();
		}
	);
	$('.toEnglish').each(function(){
		var a = $(this).parents('a')[0];
		var data = {};
		data.link = a.href;	
		a.href = '#';
		$(a).click(data, function(event){
			
			$('#skinDialogue').dialog({
				modal:true,
				autoOpen: false,
				buttons: {
					"Oui" : function(){ window.location.replace(event.data.link); },
					"Non" : function(){ $(this).dialog("close");}
				}
			});
			$('#skinDialogue').html("<p>Voulez-vous être redirigé à la version anglaise du site pour avoir accès aux dernières nouvelles?</p>");
			$('#skinDialogue').dialog("open");
			return false;
		});
	});
});

jQuery(window).load(function() {
	initDropFix();
	$(".add-block .logo img").hover(
		function() {this.src = this.src.replace(".png", "-hover.png");},
		function() {this.src = this.src.replace("-hover.png", ".png");}
	);
	$('#sub-nav div.drop li:last-child a').addClass("last");
	$('#sub-nav li:last-child a.drop-holder').addClass("last");
});

// get first and last classess where they need to be
function MenuFix(menuid,dropSpan){
	if(dropSpan){
		jQuery(menuid+' .li1').children('a').each(function(){
			var c = jQuery(this).children('span').html();
			jQuery(this).html(c);
		});
	} else {
		jQuery(menuid+' .li1').each(function(){
			if(jQuery(this).hasClass('node')){ jQuery(this).children('a').addClass('drop-holder');}
			if(jQuery(this).hasClass('last')){ jQuery(this).children('a').addClass('last');}
		});
	}
	
	jQuery(menuid+' .li2').each(function(){
		if(jQuery(this).hasClass('last')){ jQuery(this).children('a').addClass('last');}
		if(jQuery(this).hasClass('node')){ jQuery(this).children('a').addClass('drop-holder');}
	});
	jQuery(menuid+' .li3').each(function(){
		if(jQuery(this).hasClass('last')){ jQuery(this).children('a').addClass('last');}
		if(jQuery(this).hasClass('first')){ jQuery(this).children('a').addClass('first');}
	});
	//clear the classes from the lis
	jQuery(menuid+' li').removeClass('li1').removeClass('li2').removeClass('li3').removeClass('node').removeClass('first').removeClass('last').removeClass('active');
}
// drop fix init
function initDropFix() {
	var lastItem = jQuery('#nav > li').eq(jQuery('#nav > li').length - 1);
	lastItem.find('>.drop-slide-wrapper').css({left:-103});
	lastItem.find('.has-drop > .drop-slide-wrapper').hide();
}

// mobile drop init
function initMobileDrop() {
	var animSpeed = 400;
	var navItems = jQuery('#nav > li');
	var navDrops = navItems.find('.drop').hide();
	navDrops.parent().addClass('has-drop');
	navDrops.parent().find('>a').addClass('has-drop-a');
	var activeClass = 'drop-active';
	navItems.filter('.has-drop').each(function() {
		var curItem = jQuery(this);
		var opener = curItem.find('>a');
		var curDrop = curItem.find('>.drop');
		var items = curItem.find('li').filter('.has-drop');
		var drops = items.find('.drop');
		if(curDrop.length) {
			opener.bind('click', function(e) {
				if(navItems.filter('.drop-active').length && !curItem.hasClass(activeClass)) {
					var prevItem = navItems.filter('.drop-active');
					prevItem.removeClass(activeClass).find('>.drop').slideUp({duration:animSpeed, complete:function() {
						curItem.addClass(activeClass);
						curDrop.slideDown(animSpeed);
						prevItem.find('.drop').hide();
					}});
				} else {
					if(curItem.hasClass(activeClass)) {
						curItem.removeClass(activeClass);
						curDrop.slideUp({duration:animSpeed, complete:function() {
							drops.hide();
						}});
					} else {
						curItem.addClass(activeClass);
						curDrop.slideDown(animSpeed);
					}
				}
				return false;
			});
		}
		items.each(function() {
			var item = jQuery(this);
			var opener = item.find('>a');
			var drop = item.find('>.drop');
			opener.bind('click', function(e) {
				if(item.hasClass(activeClass)) {
					item.removeClass(activeClass);
					drop.slideUp(animSpeed);
				} else {
					item.addClass(activeClass);
					drop.slideDown(animSpeed);
				}
				e.preventDefault();
			});
		});
		jQuery('body').bind('click ',function(e){
			var targ = jQuery(e.target);
			if(targ.hasClass('drop') || targ.parents('.drop').length || targ.hasClass('has-drop-a')) return;
			curDrop.slideUp(animSpeed);
			drops.slideUp(animSpeed);
			items.removeClass(activeClass);
			curItem.removeClass(activeClass);
		});
	});
	
	var subItems = jQuery('#sub-nav > li');
	var subDrops = subItems.find('.drop').hide();
	subDrops.parent().addClass('has-drop');
	subDrops.parent().find('>a').addClass('has-drop-a');
	subDrops.parent().find('>a > span').addClass('has-drop-span');
	var activeClass = 'drop-active';
	subItems.filter('.has-drop').each(function() {
		var curItem = jQuery(this);
		
		var curDrop = curItem.find('>.drop');
		var items = curItem.find('li').filter('.has-drop');
		var drops = items.find('.drop');
		if(curDrop.length) {
			var opener = curItem.find('>a')
			opener.bind('click', function(e) {
				if(subItems.filter('.drop-active').length && !curItem.hasClass(activeClass)) {
					var prevItem = subItems.filter('.drop-active');
					prevItem.removeClass(activeClass);
					prevItem.find('>.drop').slideUp({duration:animSpeed, complete:function() {
						curItem.addClass(activeClass);
						curDrop.slideDown(animSpeed);
						prevItem.find('.drop').hide();
					}});
				} else {
					if(curItem.hasClass(activeClass)) {
						curItem.removeClass(activeClass);
						curDrop.slideUp({duration:animSpeed, complete:function() {
							drops.hide();
						}});
					} else {
						curItem.addClass(activeClass);
						curDrop.slideDown(animSpeed);
					}
				}
				e.preventDefault();
			});
		}
		items.each(function() {
			var item = jQuery(this);
			var opener = item.find('>a');
			var drop = item.find('>.drop');
			opener.bind('click', function(e) {
				if(item.hasClass(activeClass)) {
					item.removeClass(activeClass);
					drop.slideUp(animSpeed);
				} else {
					item.addClass(activeClass);
					drop.slideDown(animSpeed);
				}
				e.preventDefault();
			});
		});
		jQuery('body').bind('click ',function(e){
			var targ = jQuery(e.target);
			if(targ.hasClass('drop') || targ.parents('.drop').length || targ.hasClass('has-drop-a') || targ.hasClass('has-drop-span')) return;
			curDrop.slideUp(animSpeed);
			drops.slideUp(animSpeed);
			items.removeClass(activeClass);
			curItem.removeClass(activeClass);
		});
	});
}

// detect device type
var isTouchDevice = (function() {
    try {
        return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
    } catch (e) {
        return false;
    }
}());


// animated navigation init
function initDropDown() {
	jQuery('ul#nav').animDropdown({
		items: 'li',
		drop: '>div',
		animSpeed: 400,
		effect: 'slide'
	});
	jQuery('ul#sub-nav').animDropdown({
		items: 'li',
		drop: '>div',
		animSpeed: 400,
		effect: 'slide'
	});
}

// clear inputs on focus
function initInputs() {
	PlaceholderInput.replaceByOptions({
		// filter options
		clearInputs: isPublic,
		clearTextareas: isPublic,
		clearPasswords: isPublic,
		skipClass: 'default',
		
		// input options
		wrapWithElement: false,
		showUntilTyping: false,
		getParentByClass: false,
		placeholderAttr: 'value'
	});
}

/*
 * jQuery Dropdown plugin
 */
;(function($){
	$.fn.animDropdown = function(o){
		// default options
		var options = $.extend({
			hoverClass:'',
			dropClass:'drop-active',
			items: 'li',
			drop: '>ul',
			delay: 100,
			animSpeed: 300,
			effect: 'fade'
		},o);

		return this.each(function(){
			// options
			var nav = $(this);
				items = nav.find(options.items);

			items.addClass(options.hoverClass).each(function(){
				var item = $(this), delayTimer;
				var drop = item.find(options.drop);
				item.data('drop', drop);
				if(drop.length) {
					dropdownEffects[options.effect].prepare({item:item,drop:drop});
				}
				
				item.bind('mouseenter', function(){
					hideAllDropdowns(item);
					item.addClass(options.hoverClass);
					clearTimeout(delayTimer);
					delayTimer = setTimeout(function(){
						if(drop.length && item.hasClass(options.hoverClass)) {
							item.addClass(options.dropClass);
							dropdownEffects[options.effect].animate({drop:drop, state:true, speed:options.animSpeed, complete:function(){
								// callback
							}});
						}
					}, options.delay);
					item.data('timer', delayTimer);
				}).bind('mouseleave', function(){
					if(!item.hasClass(options.dropClass)) {
						item.removeClass(options.hoverClass);
					}
					clearTimeout(delayTimer);
					delayTimer = setTimeout(function(){
						if(drop.length && item.hasClass(options.dropClass)) {
							dropdownEffects[options.effect].animate({drop:drop, state:false, speed:options.animSpeed, complete:function(){
								// callback
								item.removeClass(options.hoverClass);
								item.removeClass(options.dropClass);
							}});
						}
					}, options.delay);
					item.data('timer', delayTimer);
				});
			});
			
			// hide dropdowns
			items.removeClass(options.hoverClass);
			if(dropdownEffects[options.effect].postProcess) {
				items.each(function(){
					dropdownEffects[options.effect].postProcess({item: $(this)});
				});
			}
			
			// hide current level dropdowns
			function hideAllDropdowns(except) {
				var siblings = except.siblings();
				siblings.removeClass(options.hoverClass).each(function(){
					var item = $(this);
					clearTimeout(item.data('timer'));
				});
				siblings.filter('.' + options.dropClass).each(function(){
					var item = jQuery(this).removeClass(options.dropClass);
					if(item.data('drop').length) {
						dropdownEffects[options.effect].animate({drop:item.data('drop'), state:false, speed:options.animSpeed});
					}
				});
			}
		});
	}
	
	// dropdown effects
	var dropdownEffects = {
		fade: {
			prepare: function(o) {
				o.drop.css({opacity:0,display:'none'}); 
			},
			animate: function(o) {
				o.drop.stop().show().animate({opacity: o.state ? 1 : 0},{duration: o.speed || 0, complete: function(){
					if(o.state) {
						o.drop.css({opacity:''});
					} else {
						o.drop.css({opacity:0,display:'none'});
					}
					if(typeof o.complete === 'function') {
						o.complete.call(o.drop);
					}
				}});
			}
		},
		slide: {
			prepare: function(o) {
				var elementHeight = o.drop.show().outerHeight(true);
				var elementWidth = o.drop.show().outerWidth(true);
				var elementWrap = o.drop.wrap('<div class="drop-slide-wrapper">').parent();
				elementWrap.css({
					height:elementHeight,
					width: elementWidth,
					position:'absolute',
					overflow:'hidden',
					top: o.drop.css('top'),
					left: o.drop.css('left')
				});
				o.drop.css({
					position:'static',
					display:'block',
					top: 'auto',
					left: 'auto'
				});
				o.drop.data('height', elementHeight).data('wrap', elementWrap).css({marginTop: -elementHeight}); 
			},
			animate: function(o) {
				o.drop.data('wrap').show().css({overflow:'hidden'});
				o.drop.stop().animate({marginTop: o.state ? 0 : -o.drop.data('height')},{duration: o.speed || 0, complete: function(){
					if(o.state) {
						o.drop.css({marginTop:''});
						o.drop.data('wrap').css({overflow:''});
					} else {
						o.drop.data('wrap').css({display:'none'});
					}
					if(typeof o.complete === 'function') {
						o.complete.call(o.drop);
					}
				}});
			},
			postProcess: function(o) {
				if(o.item.data('drop').length) {
					o.item.data('drop').data('wrap').css({display:'none'});
				}
			}
		}
	}
}(jQuery));

// placeholder class
;(function(){
	var placeholderCollection = [];
	PlaceholderInput = function() {
		this.options = {
			element:null,
			showUntilTyping:false,
			wrapWithElement:false,
			getParentByClass:false,
			placeholderAttr:'value',
			inputFocusClass:'focus',
			inputActiveClass:'text-active',
			parentFocusClass:'parent-focus',
			parentActiveClass:'parent-active',
			labelFocusClass:'label-focus',
			labelActiveClass:'label-active',
			fakeElementClass:'input-placeholder-text'
		}
		placeholderCollection.push(this);
		this.init.apply(this,arguments);
	}
	PlaceholderInput.refreshAllInputs = function(except) {
		for(var i = 0; i < placeholderCollection.length; i++) {
			if(except !== placeholderCollection[i]) {
				placeholderCollection[i].refreshState();
			}
		}
	}
	PlaceholderInput.replaceByOptions = function(opt) {
		var inputs = [].concat(
			convertToArray(document.getElementsByTagName('input')),
			convertToArray(document.getElementsByTagName('textarea'))
		);
		for(var i = 0; i < inputs.length; i++) {
			if(inputs[i].className.indexOf(opt.skipClass) < 0) {
				var inputType = getInputType(inputs[i]);
				if((opt.clearInputs && (inputType === 'text' || inputType === 'email')) ||
					(opt.clearTextareas && inputType === 'textarea') || 
					(opt.clearPasswords && inputType === 'password')
				) {
					new PlaceholderInput({
						element:inputs[i],
						wrapWithElement:opt.wrapWithElement,
						showUntilTyping:opt.showUntilTyping,
						getParentByClass:opt.getParentByClass,
						placeholderAttr: inputs[i].getAttribute('placeholder') ? 'placeholder' : opt.placeholderAttr
					});
				}
			}
		}
	}
	PlaceholderInput.prototype = {
		init: function(opt) {
			this.setOptions(opt);
			if(this.element && this.element.PlaceholderInst) {
				this.element.PlaceholderInst.refreshClasses();
			} else {
				this.element.PlaceholderInst = this;
				if(this.elementType !== 'radio' || this.elementType !== 'checkbox' || this.elementType !== 'file') {
					this.initElements();
					this.attachEvents();
					this.refreshClasses();
				}
			}
		},
		setOptions: function(opt) {
			for(var p in opt) {
				if(opt.hasOwnProperty(p)) {
					this.options[p] = opt[p];
				}
			}
			if(this.options.element) {
				this.element = this.options.element;
				this.elementType = getInputType(this.element);
				this.wrapWithElement = (this.elementType === 'password' || this.options.showUntilTyping ? true : this.options.wrapWithElement);
				this.setPlaceholderValue(this.options.placeholderAttr);
			}
		},
		setPlaceholderValue: function(attr) {
			this.origValue = (attr === 'value' ? this.element.defaultValue : (this.element.getAttribute(attr) || ''));
			if(this.options.placeholderAttr !== 'value') {
				this.element.removeAttribute(this.options.placeholderAttr);
			}
		},
		initElements: function() {
			// create fake element if needed
			if(this.wrapWithElement) {
				this.fakeElement = document.createElement('span');
				this.fakeElement.className = this.options.fakeElementClass;
				this.fakeElement.innerHTML += this.origValue;
				this.fakeElement.style.color = getStyle(this.element, 'color');
				this.fakeElement.style.position = 'absolute';
				this.element.parentNode.insertBefore(this.fakeElement, this.element);
				
				if(this.element.value === this.origValue || !this.element.value) {
					this.element.value = '';
					this.togglePlaceholderText(true);
				} else {
					this.togglePlaceholderText(false);
				}
			} else if(!this.element.value && this.origValue.length) {
				this.element.value = this.origValue;
			}
			// get input label
			if(this.element.id) {
				this.labels = document.getElementsByTagName('label');
				for(var i = 0; i < this.labels.length; i++) {
					if(this.labels[i].htmlFor === this.element.id) {
						this.labelFor = this.labels[i];
						break;
					}
				}
			}
			// get parent node (or parentNode by className)
			this.elementParent = this.element.parentNode;
			if(typeof this.options.getParentByClass === 'string') {
				var el = this.element;
				while(el.parentNode) {
					if(hasClass(el.parentNode, this.options.getParentByClass)) {
						this.elementParent = el.parentNode;
						break;
					} else {
						el = el.parentNode;
					}
				}
			}
		},
		attachEvents: function() {
			this.element.onfocus = bindScope(this.focusHandler, this);
			this.element.onblur = bindScope(this.blurHandler, this);
			if(this.options.showUntilTyping) {
				this.element.onkeydown = bindScope(this.typingHandler, this);
				this.element.onpaste = bindScope(this.typingHandler, this);
			}
			if(this.wrapWithElement) this.fakeElement.onclick = bindScope(this.focusSetter, this);
		},
		togglePlaceholderText: function(state) {
			if(this.wrapWithElement) {
				this.fakeElement.style.display = state ? '' : 'none';
			} else {
				this.element.value = state ? this.origValue : '';
			}
		},
		focusSetter: function() {
			this.element.focus();
		},
		focusHandler: function() {
			clearInterval(this.checkerInterval);
			this.checkerInterval = setInterval(bindScope(this.intervalHandler,this), 1);
			this.focused = true;
			if(!this.element.value.length || this.element.value === this.origValue) {
				if(!this.options.showUntilTyping) {
					this.togglePlaceholderText(false);
				}
			}
			this.refreshClasses();
		},
		blurHandler: function() {
			clearInterval(this.checkerInterval);
			this.focused = false;
			if(!this.element.value.length || this.element.value === this.origValue) {
				this.togglePlaceholderText(true);
			}
			this.refreshClasses();
			PlaceholderInput.refreshAllInputs(this);
		},
		typingHandler: function() {
			setTimeout(bindScope(function(){
				if(this.element.value.length) {
					this.togglePlaceholderText(false);
					this.refreshClasses();
				}
			},this), 10);
		},
		intervalHandler: function() {
			if(typeof this.tmpValue === 'undefined') {
				this.tmpValue = this.element.value;
			}
			if(this.tmpValue != this.element.value) {
				PlaceholderInput.refreshAllInputs(this);
			}
		},
		refreshState: function() {
			if(this.wrapWithElement) {
				if(this.element.value.length && this.element.value !== this.origValue) {
					this.togglePlaceholderText(false);
				} else if(!this.element.value.length) {
					this.togglePlaceholderText(true);
				}
			}
			this.refreshClasses();
		},
		refreshClasses: function() {
			this.textActive = this.focused || (this.element.value.length && this.element.value !== this.origValue);
			this.setStateClass(this.element, this.options.inputFocusClass,this.focused);
			this.setStateClass(this.elementParent, this.options.parentFocusClass,this.focused);
			this.setStateClass(this.labelFor, this.options.labelFocusClass,this.focused);
			this.setStateClass(this.element, this.options.inputActiveClass, this.textActive);
			this.setStateClass(this.elementParent, this.options.parentActiveClass, this.textActive);
			this.setStateClass(this.labelFor, this.options.labelActiveClass, this.textActive);
		},
		setStateClass: function(el,cls,state) {
			if(!el) return; else if(state) addClass(el,cls); else removeClass(el,cls);
		}
	}
	
	// utility functions
	function convertToArray(collection) {
		var arr = [];
		for (var i = 0, ref = arr.length = collection.length; i < ref; i++) {
			arr[i] = collection[i];
		}
		return arr;
	}
	function getInputType(input) {
		return (input.type ? input.type : input.tagName).toLowerCase();
	}
	function hasClass(el,cls) {
		return el.className ? el.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)')) : false;
	}
	function addClass(el,cls) {
		if (!hasClass(el,cls)) el.className += " "+cls;
	}
	function removeClass(el,cls) {
		if (hasClass(el,cls)) {el.className=el.className.replace(new RegExp('(\\s|^)'+cls+'(\\s|$)'),' ');}
	}
	function bindScope(f, scope) {
		return function() {return f.apply(scope, arguments)}
	}
	function getStyle(el, prop) {
		if (document.defaultView && document.defaultView.getComputedStyle) {
			return document.defaultView.getComputedStyle(el, null)[prop];
		} else if (el.currentStyle) {
			return el.currentStyle[prop];
		} else {
			return el.style[prop];
		}
	}
}());
